import React, { useEffect } from 'react';
import './EventHeroSection.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

const EventHeroSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="event-hero-section d-flex align-items-center justify-content-center">
      <div className="container">
        <div
          className="hero-text-box p-4 text-center"
          data-aos="fade-left"
          data-aos-duration="1200"
          data-aos-delay="100"
        >
          <h2 className="hero-title">
            Let’s Make Your Event<br />Unforgettable Today.
          </h2>
         <p className="hero-description">
  Elevate your brand with expertly crafted events that inspire, connect, and leave a lasting impression. We turn your vision into unforgettable experiences.
</p>
          <button className="btn talk-btn">Lets Talk Now →</button>
        </div>
      </div>
    </section>
  );
};

export default EventHeroSection;
